import { Image } from '@components/ui/image';
import SmallContainer from '@components/ui/layout/SmallContainer';
import { Text } from '@components/ui/typography';
import { spacingBottomM } from '@components/_blog-detail/spacings';
import { parse } from '@config/theme';
import { getAssetRatio } from '@lib/get-asset-ratio';
import { urlFor } from '@lib/sanity/url-for';
import { cx } from '@linaria/core';
import React, { FC } from 'react';
import { CbDualImage as CbDualImageModel } from '__generated__/sanity';
type CbDualImageProps = CbDualImageModel;
export const CbDualImage: FC<CbDualImageProps> = ({
  firstImage,
  secondImage,
  firstImageCaption,
  secondImageCaption
}) => {
  const ratio = getAssetRatio(firstImage.asset._ref);
  return <SmallContainer className={cx(spacingBottomM, container)}>
      <figure>
        <Image className={image} placeholderSrc={urlFor(firstImage).width(20).url()} sources={[urlFor(firstImage).width(720).url(), urlFor(firstImage).width(600).url()]} ratio={[ratio]} alt="" />
        {firstImageCaption && <Text variant="bodyRegular" color="shade500" mt="2" as="figcaption">
            {firstImageCaption}
          </Text>}
      </figure>
      <figure>
        <Image className={image} placeholderSrc={urlFor(secondImage).width(20).url()} sources={[urlFor(secondImage).width(720).url(), urlFor(secondImage).width(600).url()]} ratio={[ratio]} alt="" />
        {secondImageCaption && <Text variant="bodyRegular" color="shade500" mt="4" as="figcaption">
            {secondImageCaption}
          </Text>}
      </figure>
    </SmallContainer>;
};
const image = "ih2v1t9";
const container = parse({
  display: 'grid'
}, "ccg285r");

require("./index.linaria.module.css!=!../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");